<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import type { Notebook } from '@prisma/client'
import { useRadar } from '~/store/radar'
import { useDocument } from '~/store/document'
import 'highlight.js/styles/monokai.css'
import DocsAlpha from '~/components/page/assets/Alpha.vue'
import DocsBeta from '~/components/page/assets/Beta.vue'
import DocsGamma from '~/components/page/assets/Gamma.vue'

const page = 'assets'
const radar = useRadar()
const document = useDocument()
const { t } = useI18n()
const i18nHead = useLocaleHead()

useSeoMeta({
  title: () => t(`routes.${page}.title`),
  ogTitle: () => t(`routes.${page}.title`),
  description: () => t(`routes.${page}.description`),
  ogDescription: () => t(`routes.${page}.description`)
})

useHead(i18nHead.value)

useStructuredData(page)

const { routeComponents } = storeToRefs(radar)

const components = [DocsAlpha, DocsBeta, DocsGamma]

radar.setRouteComponents(components)

const { data: docs, refresh } = await useAsyncData('documents', async () => await $fetch('/api/documents'))

if (docs.value !== null) document.setDocuments(docs.value as unknown as Notebook[])
</script>

<template lang="pug">
LayoutGrid(:class="page")
  template(
    v-for="(component, index) in routeComponents"
    :key="`component-${index}`"
    #[component?.letter?.word]
  )
    component(:is="component.component")
</template>
